import { render, staticRenderFns } from "./ReAssignAsset.vue?vue&type=template&id=28ae9776&"
import script from "./ReAssignAsset.vue?vue&type=script&lang=js&"
export * from "./ReAssignAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports